<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span @click="$router.push('/auction/listview')">Auctions List View</span>
                    <span v-if="auction_name">{{ auction_name ? auction_name : "-"}}</span>
                    <a v-if="auction_name">Bidders List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center margin734">
                    <button class="btn btn-new-danger btn-wide px-6 mr-4" :disabled="selected_bidders.length == 0" @click="deleteBiddersConfirm()">- Delete</button>
                    <button class="btn btn-new-primary btn-wide px-6 mr-4" @click="showFilters"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex ml-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_bidder_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_bidder_key" v-debounce:500ms="searchBidder" debounce-events="input" placeholder="Search by Bidder Name" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
            <!-- Table Section -->
            <div class="table-block overflow-x-auto pt-10" style="background-color:#fff;border-top-right-radius:5px">
                <table class="bidder-list-table w-100">
                    <thead style="width: 100% !important">
                        <tr>
                            <th style="width: 10px !important;padding: 13px 18px !important" v-if="bidders_list.length != 0">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="select_all_bidders" @change="selectAll"/>
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th style="width: 2% !important" v-else></th>
                            <th style="width: 16% !important">
                                <span class="pointer pr-1"><img src="/static/images/double-arrow.svg" alt="" width="15px"></span>BIDDER NAME
                            </th>
                            <th style="width: 16% !important">
                                <span class="pointer pr-1"><img src="/static/images/double-arrow.svg" alt="" width="15px"></span>COMPANY NAME
                            </th>
                            <th style="width: 16% !important">CONTACT NUMBER</th>
                            <th style="width: 18% !important">EMAIL ID</th>
                            <th style="width: 16% !important">APPEAL DATE</th>
                            <th style="width: 16% !important">ADD AS LEAD</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajaxCallInProgress">
                            <td colspan="9">
                                <div class="d-flex align-items-center justify-content-center w-100">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                        style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-else-if="!ajaxCallInProgress && bidders_list.length == 0" class="text-center font-weight-bold" style="height: 400px !important;">
                            <td colspan="15">
                                <img src="/static/images/territory-sales.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/>
                                <div class="text-center">No Bidders added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(bidder, bidder_index) in bidders_list" :key="bidder_index">
                            <td style="width: 10px !important;padding: 13px 18px !important">
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="bidder.checked" @change="selectOne($event, bidder, bidder_index)"/>
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td class="pointer text-secondary" @click="goToBidderInfoView(bidder)">{{ bidder.bidder_name }}</td>
                            <td>{{ bidder.company_name ? bidder.company_name : "-" }}</td>
                            <td>{{ bidder.phone_number.phone_number }}</td>
                            <td>{{ bidder.bidder_email }}</td>
                            <td>{{ bidder.appeal_time }}</td>
                            <td v-if="bidder.show_create_lead_button == true">
                                <button class="btn btn-secondary deal-column" style="" @click="goToCreateLead(bidder)">Add Lead</button>
                            </td>
                            <td v-else>
                                <button class="btn btn-secondary deal-column" style="" @click="leadProfileModal(bidder)">View Lead</button>
                            </td>
                        </tr> 
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="bidders_list.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                     :options="pageLimit" :close-on-select="true" v-model.number="limit"
                     :max-height="210" :allow-empty="false" :searchable="false"
                     open-direction="top" :show-labels="false" placeholder=""
                     style="width: 4.2em !important;padding-right: 10px!important;">
                 </multiselect>
     
                 <span class="page-info pr-2 pl-6 fw-500 text-dark font-size-small">Per page</span>
                 <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                     <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                         <i class="icon-chevron-double-left"></i>
                     </el-tooltip>
                 </button>
                 <button @click="previousPage()" class="pagination-list mt-1 ml-2 pointer" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                     <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                         <i class="icon icon-chevron-left"></i>
                     </el-tooltip>
                 </button>
                 <span class="px-2 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                 <button @click="nextPage()" class="pagination-list mt-1 mr-2 pointer" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                     <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                         <i class="icon icon-chevron-right"></i>
                     </el-tooltip>
                 </button>
                 <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                     <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                         <i class="icon-chevron-double-right"></i>
                     </el-tooltip>
                 </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <div v-if="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <bidder-filter-data :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></bidder-filter-data>
            </div>
        </div>
        <delete-bidders v-if="delete_bidders" modal_name="delete-bidders" :selected_bidders="selected_bidders" @deleteBidders="deleteBidders" @cancelDelete="cancelDelete"></delete-bidders>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import auction from "../mixins/auction.js"
import BidderFilterData  from './BidderFilterData'
import DeleteBidders  from './DeleteBidders'
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash';
import { HalfCircleSpinner } from "epic-spinners";
export default {
    mixins: [auction],
    components: {
        HalfCircleSpinner,
        SweetModal,
        BidderFilterData,
        SweetModal,
        DeleteBidders,},
    data(){
        return {
            auction_name: "",
            success_msg: "",
            warning_msg: "",
            delete_bidders: false,
            selected_bidders: [],
            bidders_list: [],
            success_msg: "",
            warning_msg: "",
            search_bidder_key: "",
            select_all_bidders: false,
            display_filters: false,
            hide_filters: false,
            skip: 0,
            limit: 10,
            skip_temp: 0,
            total: 0,
            temp_total: 0,
            pageLimit: [],
            ajaxCallInProgress: false,
            auction_create_lead: [],
            filterData: {
                auction_id: [this.$route.params.id],
                bidder_name: [],
                company_name: [],
                appeal_date: ""

            },
            showfilterData: {
                auction_id: [this.$route.params.id],
                bidder_name: [],
                company_name: [],
                appeal_date: ""
            }
        }
    },
    methods: {
        clearSearch(){
            this.search_bidder_key = "";
            this.$refs.searchInput.focus();
            this.searchBidder();
        },
        leadProfileModal(bidder){
            localStorage.setItem("selected_lead_id", bidder.lead_id)
            localStorage.setItem("leads_type",bidder.lead_type == 'active' ? 'Manual' : bidder.lead_type == 'archive' ? 'Archive' : 'converted')
            // this.$router.push(`/leads/LeadProfile_Dashboard`);
            let routeData = this.$router.resolve({name: 'leads/LeadProfile_Dashboard'});
            window.open(routeData.href+'leads/LeadProfile_Dashboard', '_blank');
        },
        //Passes parameters to show filtered data
        UpdateByFilter(params){
            this.skip = 0
            this.limit = 10
            this.showfilterData = {
                auction_id: params.value1.auction_id,
                bidder_name:params.value1.bidder_name,
                company_name:params.value1.company_name,
                appeal_date:params.value1.appeal_date,
            }
            this.filterData = {
                // company_name: params.value1.company_name == null || params.value1.company_name == '' ? [] : [params.value1.company_name] ,
                // contact_name:params.value1.contact_name,
                auction_id: params.value1.auction_id,
                bidder_name:params.value1.bidder_name,
                company_name:params.value1.company_name,
                appeal_date:params.value1.appeal_date,
            }
            this.loadBiddersData();
        },
        goToBidderInfoView(bidder){
            this.$router.push('/auction/bidderinfoview/'+bidder.id)
        },
        //Redirects to create lead page
        goToCreateLead(bidder){
            this.auction_create_lead = bidder;
            localStorage.setItem('auction_data', JSON.stringify(this.auction_create_lead))
            if(bidder.company_name == ""){
                // this.$router.push('/leads/createLeads/individual/new')
                let routeData = this.$router.resolve({name: 'leads/createLeads/individual/new'});
                window.open(routeData.href+'leads/createLeads/individual/new', '_blank');
            } else {
                let routeData = this.$router.resolve({name: 'leads/createLeads/new'});
                window.open(routeData.href+'leads/createLeads/new', '_blank');
                // this.$router.push('/leads/createLeads/new')
            }
        },
        //Pagination methods
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadBiddersData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.loadBiddersData();
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.loadBiddersData();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadBiddersData();
        },
        cancelDelete(){
            this.delete_bidders = false;
        },
        //OPens delete alert popup
        deleteBiddersConfirm(){
            this.delete_bidders = true;
            setTimeout(() => {
                this.$modal.show("delete-bidders");
            }, 500);
        },
        //API call to delete slected bidders
        async deleteBidders(){
            try {
                let params = {
                    bidder_id: this.selected_bidders
                }
                let response = await this.deleteBiddersByID(params)
                this.cancelDelete();
                if (response.status_id == 1) {
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.selected_bidders = [];
                        this.loadBiddersData();
                        this.$refs.success_modal.close();
                    }, 3000);
                }
            } catch (error) {
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //Single Select checkbox function
        selectOne(event, bidder, bidder_index) {
            if(event.target.checked){
                this.selected_bidders.push(bidder.id)
            } else {
                this.selected_bidders.forEach((selected_bid, selected_bid_index) => {
                    if(selected_bid === bidder.id){
                        this.selected_bidders.splice(selected_bid_index, 1)
                    }
                })
            }
            if(this.bidders_list.every(x => x.checked == true)){
                this.select_all_bidders = true;
            } else {
                this.select_all_bidders = false;
            }
        },
        //Select all checkbox method
        selectAll(event) {
            if(event.target.checked === true){
                this.bidders_list.forEach((bidders, index) => {
                    if(this.bidders_list[index].checked == false){
                        this.bidders_list[index].checked = true;
                        this.selected_bidders.push(bidders.id)
                    }
                })
            } else {
                this.bidders_list.forEach((bidders, index) => {
                    this.bidders_list[index].checked = false;
                })
                this.bidders_list.forEach((bid_list, contact_list_index) => {
                    this.selected_bidders.forEach((selected_bid, selected_bid_index) => {
                        if(bid_list.id == selected_bid){
                            this.selected_bidders.splice(selected_bid_index, 1)
                        }
                    })
                })
            }
        },
        showFilters(){
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
        },
        //API call to get all bidders data
        async loadBiddersData(){
            this.ajaxCallInProgress = true;
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_bidder_key,
                    sort_key: "bidder_name",
                    sort_value: -1,
                    filter: this.filterData
                }
                let response = await this.getBiddersData(params);
                this.bidders_list = response.response;
                this.total = response.total_count;
                this.auction_name = response.auction_name;
                if(this.bidders_list.length != 0){
                    this.bidders_list.forEach((bidders_cont, idders_cont_index) => {
                        this.bidders_list[idders_cont_index].checked = false;
                        if(this.selected_bidders.length){
                            this.selected_bidders.forEach((selected, selected_index) => {
                                if(selected === bidders_cont.id){
                                    this.bidders_list[idders_cont_index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.bidders_list.every(x => x.checked == true)){
                        this.select_all_bidders = true;
                    } else {
                        this.select_all_bidders = false;
                    }
                }
            } catch (error) {
                
            }
            this.ajaxCallInProgress = false;
        },
        //API call to search bidders
        async searchBidder(){
            this.ajaxCallInProgress = true;
            try {
                let params = {
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    skip: this.skip,
                    search_key: this.search_bidder_key,
                    sort_key: "bidder_name",
                    sort_value: -1,
                    filter: {
                        auction_id: [this.$route.params.id],
                        bidder_name: [],
                        company_name: [],
                        appeal_date: ""
                    }
                }
                let response = await this.getBiddersData(params);
                this.bidders_list = response.response;
                this.total = this.bidders_list.length
                if(this.bidders_list.length != 0){
                    this.bidders_list.forEach((bidders_cont, idders_cont_index) => {
                        this.bidders_list[idders_cont_index].checked = false;
                        if(this.selected_bidders.length){
                            this.selected_bidders.forEach((selected, selected_index) => {
                                if(selected === bidders_cont.id){
                                    this.bidders_list[idders_cont_index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.bidders_list.every(x => x.checked == true)){
                        this.select_all_bidders = true;
                    } else {
                        this.select_all_bidders = false;
                    }
                }
            } catch (error) {
                
            }
            this.ajaxCallInProgress = false;
        },
    },
    mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.loadBiddersData();
    },
    computed: {
        getSkipCount() {
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
    watch: {
        limit: function(){
            this.loadBiddersData();
        }
    },
}
</script>
<style scoped>
    .bidder-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .bidder-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .bidder-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .bidder-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .bidder-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .scm-filters{
        height: fit-content !important;
        padding-bottom: 20px !important;
        overflow: auto !important;
    }
    .btn-secondary {
        color: #fff;
        background-color: #00448b;
        border-color: #00448b;
        border-radius: 8px !important;
        box-shadow: none !important;
        font-weight: 500;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media only screen and (max-width: 734px) {
        .margin734{
            margin-bottom: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Auction/BidderListView.vue